











































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import GlobalMixins from '../mixins';

import OptionsHeader from '@/components/OptionsHeader.vue'
import { IStatement, IUserChoice, IData } from '../interfaces';

@Component({
	components: {
		OptionsHeader
	}
})
export default class SelectStatements extends GlobalMixins {
	selectedStatements: number[] = [];
	hoveredStatementId: number = 0;
	
	get subtitle(): string {
		return `<strong>${this.selectedStatements.length}/</strong>${this.config.settings.maxSelectedStatements} ${this.dictionary.selectStatements.subtitle}`
	}
	get ariaSubtitle(): string {
		return `${this.selectedStatements.length} ${this.dictionary.selectStatements.accessibility.subtitleStatementOfMax} ${this.config.settings.maxSelectedStatements} ${this.dictionary.selectStatements.accessibility.subtitle ? this.dictionary.selectStatements.accessibility.subtitle : this.dictionary.selectStatements.subtitle}`
	}
	get statementsColumns(): {left: IStatement[], center: IStatement[], right: IStatement[]} {
		let statements = this.statements
		const userChoices = this.user.choices
		let sortedStatements: any = [[], [], []]

		statements = statements.filter((statement: IStatement) => {
			let statementIsSkipped = false

			userChoices.forEach((selection: IUserChoice) => {
				if (selection.originalStatementId === statement.id && selection.choice === 'skip') statementIsSkipped = true
			})

			return !statementIsSkipped
		})

		if (statements.length) {
			const statementsPerColumn = Math.ceil(statements.length / 3)

			for (let column = 0; column < 3; column++) {
				for (let i = 0; i < statementsPerColumn; i++) {
					const value = statements[i + column * statementsPerColumn]

					if (!value) continue

					sortedStatements[column].push(value)
				}
			}
		}

		sortedStatements = {
			left: sortedStatements[0],
			center: sortedStatements[1],
			right: sortedStatements[2]
		}

		return sortedStatements
	}
	get skippedTooManyStatements(): boolean {
		return (this.amountSkipped < (this.statements.length / 2))
	}

	@Watch('selectedStatements')
	onSelectedStatementsChange() {
		this.$store.dispatch('setPriotityStatements', this.selectedStatements.length === 0 ? false : this.selectedStatements)
		this.$store.dispatch('setSavedResults', false)
	}

	toggleStatement(statementId: number): void {
		if (this.selectedStatements.indexOf(statementId) === -1) {
			if (this.selectedStatements.length === this.config.settings.maxSelectedStatements) return

			this.selectedStatements.push(statementId)
		} else {
			this.selectedStatements.splice(this.selectedStatements.indexOf(statementId), 1)
		}
		(document.activeElement as HTMLElement)?.blur();
	}
	next() {
		if (this.skippedTooManyStatements || this.$store.getters.showRoadrunnerError) {
			return;
		}
		
		this.$router.push({ name: 'select-parties' })
	}

	created() {
		const user = this.user

		if (user.priorityStatements) {
			this.selectedStatements = user.priorityStatements
		}

		document.addEventListener("keyup", (e) => {
			if (e.code === "Escape") {
				this.hoveredStatementId = 0;
			}
		});
	}
}
